module.exports = __webpack_public_path__ + "media/images/pencil-65af7fbedbf6e037b01acadeea9195d1.png";